import React from 'react';
import { Checkbox, Col, Form, Input, Row, Space, Typography } from 'antd';
import { ElectronicContractTemplateDefinition } from '@/core/models/electronic-contract.model';
import { getCreationFields } from './creation-draft';

export const contractFieldLabels: Record<string, string> = {
    MaKhachHang: 'Mã khách hàng', MaHopDong: 'Số hợp đồng', TenKhachHang: 'Tên khách hàng', CCCD: 'Số CCCD',
    NgayCap: 'Ngày cấp CCCD', NoiCap: 'Nơi cấp CCCD', DiaChi: 'Địa chỉ khách hàng', SoDienThoai: 'Số điện thoại',
    NgayLap: 'Ngày lập', DiaChiDatDongHo: 'Địa chỉ lắp đồng hồ', DiaDiemNghiemThu: 'Địa điểm nghiệm thu',
    NgayNghiemThu: 'Ngày nghiệm thu', NgayLapDat: 'Ngày lắp đặt', ChiSoDongHo: 'Chỉ số đồng hồ', MaDongHo: 'Mã đồng hồ',
    NgayKhaoSat: 'Ngày khảo sát', DiaDiemKhaoSat: 'Địa điểm khảo sát', MucDichSuDung: 'Mục đích sử dụng',
    NgayDuKienLapDat: 'Ngày dự kiến lắp đặt', ChiPhiPhatSinh: 'Chi phí phát sinh (VND)', ChiPhiBangChu: 'Chi phí bằng chữ',
    SoBienBan: 'Số biên bản', NgayBanGiao: 'Ngày bàn giao', DiaDiemBanGiao: 'Địa điểm bàn giao',
    HieuDongHo: 'Hiệu đồng hồ', LoaiDongHo: 'Loại đồng hồ', SoChi: 'Số chì', ChiSoBanGiao: 'Chỉ số bàn giao',
    ChiSoTinhTienNuoc: 'Chỉ số tính tiền nước', NgayTinhTienNuoc: 'Ngày tính tiền nước',
    NgayHopDong: 'Ngày hợp đồng', DiaDiemKy: 'Địa điểm ký', KhuVuc: 'Khu vực', ViTriDauNoi: 'Vị trí đấu nối',
    DaiDienBenB: 'Người đại diện bên B', ChucVuBenB: 'Chức vụ đại diện bên B', STKNHang: 'Số tài khoản ngân hàng', TNHang: 'Tên ngân hàng',
    TenToChuc: 'Tên pháp lý tổ chức (đã xác nhận)', MaSoThue: 'Mã số thuế tổ chức', DiaChiTruSo: 'Địa chỉ trụ sở đăng ký',
    TenNguoiDaiDien: 'Họ tên người đại diện ký', ChucVu: 'Chức vụ người đại diện', CanCuDaiDien: 'Căn cứ đại diện',
    EmailNguoiKy: 'Email người ký nhận OTP', SoDienThoaiNguoiKy: 'Số điện thoại người ký',
    SoThanhLy: 'Số thanh lý', NgayThanhLy: 'Ngày thanh lý', NgayChamDut: 'Ngày chấm dứt', NgayChotCuoi: 'Ngày chốt cuối',
    SoSeri: 'Số sê-ri đồng hồ', ChiSoDau: 'Chỉ số đầu', ChiSoCuoi: 'Chỉ số cuối', SanLuongCuoi: 'Sản lượng cuối',
    TienNuoc: 'Tiền nước (VND)', ThueGTGT: 'Thuế GTGT (VND)', PhiBVMT: 'Phí BVMT (VND)', PhiKhac: 'Phí khác (VND)',
    DaThanhToan: 'Đã thanh toán (VND)', ConPhaiTra: 'Còn phải trả (VND)', HanThanhToan: 'Hạn thanh toán',
    LyDoKhac: 'Diễn giải lý do khác', NguoiNhanDongHo: 'Người nhận đồng hồ', XuLyKhac: 'Diễn giải xử lý khác',
    MD1: 'Nước sạch dùng cho hộ dân cư', MD2: 'Nước sạch dùng cho cơ quan hành chính sự nghiệp', MD3: 'Nước sạch dùng cho sản xuất vật chất', MD4: 'Nước sạch dùng cho kinh doanh dịch vụ',
    LD1: 'Khách hàng không còn nhu cầu sử dụng nước', LD2: 'Thay đổi chủ thể ký kết hợp đồng', LD3: 'Chuyển nhượng/chuyển quyền sử dụng địa điểm', LD4: 'Theo thỏa thuận của các bên', LD5: 'Do một bên vi phạm nghĩa vụ theo hợp đồng', LD6: 'Lý do khác',
    XL1: 'Đã tháo và thu hồi đồng hồ nước', XL2: 'Đã khóa/ngừng cấp nước, đồng hồ giữ nguyên tại vị trí', XL3: 'Bàn giao đồng hồ cho', XL4: 'Trường hợp khác',
    TT1: 'Hoạt động bình thường', TT2: 'Hư hỏng sửa chữa được', TT3: 'Hư hỏng không sửa chữa được',
    LyDoChamDut: 'Lý do chấm dứt', XuLyDongHo: 'Xử lý đồng hồ', TinhTrangDongHo: 'Tình trạng đồng hồ',
};

interface ContractFieldsProps {
    definition: ElectronicContractTemplateDefinition;
    values: Record<string, string>;
    disabled: boolean;
    onChange: (name: string, value: string) => void;
}

export function ContractFields({ definition, values, disabled, onChange }: ContractFieldsProps) {
    const fields = getCreationFields(definition);
    const selections = fields.filter(field => field.format === 'checkbox');
    const groups = definition.selectionGroups ?? [];
    const formatHelp = (format: string) => {
        if (format.startsWith('date-')) return 'yyyy-MM-dd hoặc dd/MM/yyyy';
        if (format === 'integer-vnd') return 'Số nguyên VND, không dấu phân cách (150000)';
        if (format === 'decimal-nonnegative') return 'Số không âm; dấu thập phân . (12.5)';
        return undefined;
    };
    return <>
        <Typography.Paragraph type="secondary">
            Để trống trường có dữ liệu nguồn để dùng thông tin khách hàng. Bấm xem trước để kiểm tra dữ liệu thực tế và các mục còn thiếu.
            Số hợp đồng, thông tin tổ chức và người ký cần được nhân viên xác nhận. Mã khách hàng và từng ô mã do hệ thống điền.
        </Typography.Paragraph>
        <Row gutter={[20, 0]}>
            {fields.filter(field => field.format !== 'checkbox').map(field => <Col xs={24} md={12} key={field.name}>
                <Form.Item label={<span>{contractFieldLabels[field.name] ?? field.name}{field.required ? ' *' : ''}</span>}
                    extra={field.requiredWhen ? `Bắt buộc khi ${field.requiredWhen}` : formatHelp(field.format)}>
                    <Input id={`contract-field-${field.name}`} aria-label={contractFieldLabels[field.name] ?? field.name}
                        disabled={disabled} value={values[field.name] ?? ''} autoComplete="off"
                        inputMode={field.format === 'integer-vnd' ? 'numeric' : field.format === 'decimal-nonnegative' ? 'decimal' : undefined}
                        placeholder={formatHelp(field.format) ?? (definition.requiredInputs.includes(field.name) ? 'Nhập thông tin đã kiểm tra' : 'Dùng dữ liệu nguồn nếu có')}
                        onChange={event => onChange(field.name, event.target.value)} />
                </Form.Item>
            </Col>)}
        </Row>
        {groups.map(group => <Form.Item key={group.name} label={`${contractFieldLabels[group.name] ?? group.name} (chọn theo chứng từ)`}>
            <Space wrap size={[24, 12]}>
                {group.fields.map(name => selections.find(field => field.name === name)).filter(Boolean).map(field => field && <Checkbox
                    key={field.name} disabled={disabled} checked={values[field.name] === '☒'}
                    onChange={event => onChange(field.name, event.target.checked ? '☒' : '☐')}>
                    {contractFieldLabels[field.name] ?? field.name} ({field.name}): {values[field.name] === '☒' ? '☒' : '☐'}
                </Checkbox>)}
            </Space>
            <div><Typography.Text type="secondary">Chọn đúng các mục trên chứng từ đã kiểm tra.</Typography.Text></div>
        </Form.Item>)}
        {selections.filter(field => !groups.some(group => group.fields.includes(field.name))).map(field => <Form.Item key={field.name}>
            <Checkbox disabled={disabled} checked={values[field.name] === '☒'} onChange={event => onChange(field.name, event.target.checked ? '☒' : '☐')}>
                {contractFieldLabels[field.name] ?? field.name} ({field.name}): {values[field.name] === '☒' ? '☒' : '☐'}
            </Checkbox>
        </Form.Item>)}
    </>;
}
